import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};

const PrimaryContentPane = ({ children }: Props) => {
  return <div styleName="primary-content-pane">{children}</div>;
};

export default PrimaryContentPane;
